import { render, staticRenderFns } from "./CharacterEditingDialog.vue?vue&type=template&id=56d3c606&lang=pug&"
import script from "./CharacterEditingDialog.vue?vue&type=script&lang=js&"
export * from "./CharacterEditingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterEditingDialog.vue"
export default component.exports